<script>
import Vue from "vue";
import { mapState } from "vuex";
import { get, keys } from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
  }
});

window.vueRecaptchaApiLoaded = () => {
  console.log("The reCAPTCHA has been loaded");
};

const FIRST = 0;
const SECOND = 1;

export default {
  name: "forgotpasswordform",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.recaptcha();
    this.$validator.extend("cpf", {
      getMessage: (field) => `O ${field} informado não é válido`,
      validate: (value) => {
        const cpfReg = /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-?[0-9]{2}$/;
        if (!value.match(cpfReg)) return false;

        const replaced = value.replace(/[.-]/g, "");

        const validateDigit = (start, end, fromStart) => {
          let sum = 0;
          const limit = fromStart ? 11 : 12;
          for (let i = 0; i < start; i++)
            sum += parseInt(replaced.substring(i, i + 1)) * (limit - (i + 1));
          let rest = (sum * 10) % 11;
          if (rest === 10 || rest === 11) rest = 0;
          return rest === parseInt(replaced.substring(start, end));
        };

        return validateDigit(9, 10, true) && validateDigit(10, 11, false);
      },
    });
  },
  data: () => ({
    buttons: [
      {
        label: "E-mail",
        activated: true,
        disabled: false,
      },
      {
        label: "CPF",
        activated: false,
        disabled: false,
      },
    ],
    email: null,
    maskedEmail: null,
    cpf: null,
    successfullyCheckMessage: null,
    successfullyRecovery: false,
    successfullyResent: false,
    notRegistered: false,
    countdown: 60,
    api_error: null,
  }),
  computed: {
    ...mapState("company", ["company"]),
    logo() {
      return get(this.$store, "state.company.company.logo_url", null);
    },
    color() {
      return "#1551B1";
    },
    title() {
      return !this.successfullyRecovery ? "Esqueceu sua senha?" : "Link enviado";
    },
    subtitle() {
      return !this.successfullyRecovery
        ? "Não se preocupe, vamos te enviar instruções de como recuperar sua conta"
        // : `Um link para redefinição de senha foi enviado para o e-mail ${this.maskedEmail}`;
        : ((this.cpf === null) ? `Caso o email exista em nossa base de dados, o link para redefinição de senha foi enviado com sucesso!` 
            : `Um link para redefinição de senha foi enviado para o e-mail ${this.maskedEmail}`);
    },
    isAnonimous() {
      return (
        get(this.$router, "history.current.params.company_label", null) === "anonima"
      );
    },
    countdownInMinutes() {
      return `${Math.floor(this.countdown / 60)}:${this.countdown % 60}`;
    },
    allowSubmit() {
      return this.buttons[FIRST].activated
        ? this.email
        : this.cpf && this.cpf.length === 14;
    },
  },
  methods: {
    shouldShowCompanyLogo() {
      return keys(this.company).length > 0;
    },
    changeButton(i) {
      if (i === SECOND && this.buttons[FIRST].activated) {
        this.buttons[FIRST].activated = !this.buttons[FIRST].activated;
        this.buttons[i].activated = !this.buttons[i].activated;
      } else {
        this.buttons[SECOND].activated = !this.buttons[SECOND].activated;
        this.buttons[i].activated = !this.buttons[i].activated;
      }

      this.email = null;
      this.cpf = null;
      this.api_error = null;
      this.notRegistered = false;
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.countdown = 60;
          this.successfullyResent = false;
        }
      }, 1000);
    },
    async handleRecovery() {
      this.$vs.loading();
      try {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          this.api_error = "Preencha os campos corretamente"
          return;
        }

        const { company_label } = this.$router.history.current.params;

        const payload = this.buttons[FIRST].activated
          ? { email: this.email, label: company_label }
          : { cpf: this.cpf, label: company_label };

        const { status, data } = await this.$http.post("api/v1/forget/password", payload);

        if (status === 200) {
          this.successfullyRecovery = true;
          this.maskedEmail = get(data, "data.email", null);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Falha ao redefinir senha",
          text: get(error, 'response.data.message', 'Falha ao realizar o procedimento contate a nossa equipe de suporte'),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
        this.recaptcha();
      }
    },
    async handleResendEmail() {
      this.$vs.loading();
      try {
        const { company_label } = this.$router.history.current.params;

        const payload = this.buttons[FIRST].activated
          ? { email: this.email, label: company_label }
          : { cpf: this.cpf, label: company_label };

        await this.$http.post("api/v1/forget/password", payload);

        this.successfullyResent = true;
        this.startTimer();
      } catch (error) {
        this.$vs.notify({
          title: "Falha ao reenviar e-mail",
          text: get(error, 'response.data.message', 'Falha ao realizar o procedimento contate a nossa equipe de suporte'),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
        this.recaptcha();
      }
    },
    async recaptcha() {
      try {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('login');
        if (token) {
          this.$http.defaults.headers.common['X-Recaptcha-Token'] = token;
        }
      } catch (error) {
        // console.log(error);
      }
    },
    handleGoToBack() {
      this.$router.back();
    },
    handleOpenEmail() {
      window.open(`mailto:${this.email}`);
    },
  },
  watch: {
    cpf: async function (val) {
      if (!val || typeof val !== "string") {
        return;
      }

      val = val.replace(/[^0-9]/g, "");

      if (val.length <= 3) {
        this.cpf = val;
      } else if (val.length <= 6) {
        this.cpf = `${val.slice(0, 3)}.${val.slice(3)}`;
      } else if (val.length <= 9) {
        this.cpf = `${val.slice(0, 3)}.${val.slice(3, 6)}.${val.slice(6)}`;
      } else {
        this.cpf = `${val.slice(0, 3)}.${val.slice(3, 6)}.${val.slice(6, 9)}-${val.slice(
          9
        )}`;
      }
    },
  },
};
</script>

<template>
  <div class="forgot-password-form">
    <img
      class="forgot-password-form__logo"
      alt="Company Logo"
      :src="logo"
      v-show="shouldShowCompanyLogo() && !isAnonimous"
    />
    <h2>{{ title }}</h2>
    <p>{{ subtitle }}</p>
    <div v-if="!successfullyRecovery" class="buttons-wrapper">
      <button
        v-for="(button, i) in buttons"
        :key="`btn-${button.label}`"
        :class="button.activated ? 'activated' : 'desactivated'"
        :style="button.activated ? { color: color } : ''"
        :disabled="button.disabled"
        @click="() => changeButton(i)"
      >
        {{ button.label }}
      </button>
    </div>
    <ValidationObserver
      v-if="!successfullyRecovery"
      ref="observer"
      tag="form"
      @submit.prevent="handleRecovery()"
    >
      <ValidationProvider
        v-if="buttons[0].activated"
        name="email"
        rules="required|email"
        v-slot="{ errors }"
      >
        <vs-input
          class="input"
          icon="email"
          type="email"
          v-model="email"
          label-placeholder="Email"
          :danger="errors.length > 0"
          :danger-text="errors[0]"
        />
        <span v-if="api_error" class="text-danger text-sm">
          {{ api_error }}
        </span>
      </ValidationProvider>

      <ValidationProvider
        v-if="buttons[1].activated"
        vid="cpf"
        name="cpf"
        rules="required|cpf"
        placeholder="CPF (Somente números)"
        v-slot="{ errors }"
      >
        <vs-input
          class="input"
          icon="verified_user"
          type="text"
          v-model="cpf"
          label-placeholder="CPF"
          :danger="errors.length > 0"
          :danger-text="errors[0]"
        />
        <span v-if="api_error" class="text-danger text-sm">
          {{ api_error }}
        </span>
      </ValidationProvider>
      <button class="submit-btn bg-primary" type="submit">
        Enviar
      </button>
    </ValidationObserver>
    <!-- <button
      v-if="successfullyRecovery"
      class="submit-btn bg-primary"
      type="button"
      @click="handleOpenEmail"
    >
      Abrir e-mail
    </button> -->
    <p
      v-if="successfullyRecovery && !successfullyResent"
      class="account__paragraph mt-10"
    >
      E-mail não chegou?
      <vs-button type="flat" class="account-link p-0" @click="handleResendEmail">
        Reenviar e-mail
      </vs-button>
    </p>
    <p
      v-if="successfullyRecovery && successfullyResent"
      class="account__paragraph mt-10"
    >
      Tempo de espera para reenviar o link novamente
      <span class="account-link">{{ countdownInMinutes }}</span>
    </p>
    <vs-button
      v-if="!successfullyRecovery"
      type="flat"
      icon="arrow_back_ios"
      class="back-btn"
      @click="handleGoToBack"
    >
      Voltar
    </vs-button>
  </div>
</template>

<style lang="scss" scoped>
.create-account {
  margin: 3rem 0 2rem 0;
  display: flex;
  justify-content: center;

  & > button {
    width: 100%;
  }
}
.forgot-password-form {
  width: 360px;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 1rem;
  gap: 1rem;

  h2 {
    align-self: stretch;
    color: #42526e;
    font-family: Roboto;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: 0.52px;
  }

  p {
    color: #42526e;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.4px;
  }

  &__logo {
    max-width: 130px;
    max-height: 150px;
    margin: 0 auto;
    margin-bottom: 05px;
    margin-top: 10px;
    object-fit: contain;
  }
}

p.account__paragraph {
  font-size: 14px;
  text-align: center;
  margin-top: -1rem;
  margin-bottom: 1rem;

  a {
    font-weight: 500;
  }
}

.account-link {
  font-size: 14px;
  padding: 0;
  margin-left: 4px;
  color: #1551b1;
}

.buttons-wrapper {
  display: flex;
  gap: 1rem;

  button {
    width: fit-content;
    background: #fff;
    padding: 8px;
    border: none;
    border-bottom: 3px solid;
    cursor: pointer;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: 0.32px;
  }

  .activated {
    color: #1551b1;
  }

  .desactivated {
    border: none;
    color: #42526e;
    font-weight: 500;
  }
}

.input {
  width: 100%;
  margin-top: 1rem;
}

.submit-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.85rem 2.5rem;
  color: white;
  font-size: 16px;
  font-weight: 200;
  border: 0px;
  border-radius: 5px;

  margin: 20px 0 20px 0;
  transition: color 0.5s;

  &:hover {
    color: #fcfcfc;
    cursor: pointer;
  }
}

.back-btn {
  color: #42526e;
  padding: 0;
  font-size: 14px;
  margin-top: -20px;
}
</style>
